import desktop from './desktop'
import mobile from './mobile'

export default {
  desktop,
  mobile
}
